export enum EThemes {
    PROBLEMS_REPORT,
    GET_CONSULTATION,
    BECOME_CLIENT,
    COMPLAIN,
    OTHER,
}

export interface IInputValue {
    readonly isValid: boolean,
    readonly value: string,
    readonly clearInput?: () => void,
}

export interface ITheme {
    code: EThemes,
    label: string,
    isHighlight?: boolean,
}

export interface IRenderSelect {
    themes: ITheme[],
    highlightIndex: number,
    onSelectTheme: (theme: ITheme, index: number) => void,
}

export const INITIAL_THEME = 2;

export const THEMES: ITheme[] = [
    {
        code: EThemes.PROBLEMS_REPORT,
        label: 'Сообщить о неполадках',
    },
    {
        code: EThemes.GET_CONSULTATION,
        label: 'Получить консультацию',
    },
    {
        code: EThemes.BECOME_CLIENT,
        label: 'Стать клиентом',
    },
    {
        code: EThemes.COMPLAIN,
        label: 'Пожаловаться',
    },
    {
        code: EThemes.OTHER,
        label: 'Другое',
    },
];

export interface IRenderFormProps {
    readonly theme: ITheme,
    readonly fio: IInputValue,
    readonly phone: IInputValue,
    readonly onEditFio: (fio: IInputValue) => void,
    readonly onEditPhone: (phone: IInputValue) => void,
    readonly onChangeTheme: () => void,
    readonly onSendRequest: () => void,
    readonly isValid: boolean,
    readonly isLoading: boolean,
    readonly isError: boolean,
    readonly message: string | null | undefined,
    readonly policyLink: string,
    readonly onChangeHandle: (theme:ITheme) => void,
    readonly openChatHandler: () => void,
}
export type TField = {
    value: string,
    isValid: boolean,
    clearInput: () => void,
}
export interface ISendRequestHandleProps {
    theme: ITheme,
    fioValue: string,
    phoneValue: string,
}

export type TSendRequestHandle= ({ theme, fioValue, phoneValue }: ISendRequestHandleProps) => Promise<{
    isError: boolean,
    message: string | null | undefined,
}>;
